import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import React from "react";
import { ui } from "../../../../../../interfaces/interfaces";

const name = "OpenFormButton";

const OpenFormButton: React.FC = () =>
(<Grid
    size={{
        xs: 12,
        sm: 12
    }}>
    <Paper elevation={4} sx={(theme) => ({
        padding: theme.spacing(1),
        textAlign: "center",
    })}>
        <Button color="primary" onClick={() => ui.NewBookingDialogModal = true} variant="contained">OPEN BOOKING FORM</Button>
    </Paper>
</Grid>
)
OpenFormButton.displayName = name;

export default React.memo(OpenFormButton);